var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"assignment-type"},[_c('div',{staticClass:"assignment-type__wrapper",class:[_vm.typeClass]},[_c('p',{staticClass:"assignment-type__data"},[_vm._v(_vm._s(_vm.data.typeText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }